import { useNavigate } from 'react-router-dom';

import { AppIcon } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { NuggetChip } from '@backrs_ui/grow-ui/src/components/Nuggets/NuggetChip';
import type { UserCollege } from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

import { Box, SxProps, Theme } from '@mui/material';

type ChipCollege = Pick<UserCollege, 'name' | 'logo_media_url'> &
  Partial<Pick<UserCollege, 'academic_profile_id'>>;

type CollegeChipProps = Readonly<{
  id: string;
  college: ChipCollege;
  onRemove?: () => void;
  size?: 'sm' | 'lg';
}>;

export const CollegeChip = ({ id, college, onRemove, size }: CollegeChipProps) => {
  const navigate = useNavigate();
  const { academic_profile_id: academicProfileId } = college;

  return (
    <Box component="span" title={college.name} sx={wrapperSx}>
      <NuggetChip
        id={id}
        label={college.name}
        image={
          college.logo_media_url ? { src: college.logo_media_url, alt: college.name } : undefined
        }
        icon={<AppIcon iconName="Building07" diameter="14px" color="Gray/500" />}
        onClick={
          academicProfileId
            ? () => navigate(`${APP_ROUTE.UNIVERSITY}/${academicProfileId}`)
            : undefined
        }
        onRemove={onRemove}
        size={size}
        sx={chipSx}
      />
    </Box>
  );
};

const wrapperSx: SxProps<Theme> = {
  display: 'inline-flex',
  maxWidth: 'min(100%, 320px)',
  minWidth: 0,
};

const chipSx: SxProps<Theme> = {
  maxWidth: '100%',
};
